var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_687","data-name":"Group 687","transform":"translate(-1307 -310)"},[React.createElement("circle",{"id":"Ellipse_208","data-name":"Ellipse 208","cx":"16.5","cy":"16.5","r":"16.5","transform":"translate(1307 310)","fill":"#232323","key":0}),React.createElement("path",{"id":"close","d":"M13.133,14.541,7.5,8.908,8.908,7.5l5.633,5.633L20.174,7.5l1.408,1.408-5.633,5.633,5.633,5.633-1.408,1.408-5.633-5.633L8.907,21.583,7.5,20.174Z","transform":"translate(1308.959 311.959)","fill":"#fff","fillRule":"evenodd","key":1})]));
}

Close.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33"};

module.exports = Close;

Close.default = Close;
